import React from "react";
import {
    ContainerTitle,
    SubTitleProduct,
    TitleProduct,
} from './articulosComponents.elements'

function NameProduct(props) {
    return (
        <React.Fragment>
            <ContainerTitle>
                <div>
                    <TitleProduct>{props.title}</TitleProduct>
                    <SubTitleProduct>
                        {props.lab}. Ref: {props.referencia}
                    </SubTitleProduct>
                </div>
            </ContainerTitle>
        </React.Fragment>
    );
}

export {NameProduct};